import api from "./api";
import {
  Incorporadora,
  IncorporadoraCreate,
  IncorporadoraUpdate,
} from "../types/incorporadora";

const BASE_URL = "/api/incorporadoras/";

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// Backend usa LimitOffsetPagination com PAGE_SIZE=10 (rest_framework.settings,
// sem override no IncorporadoraViewSet) — getAll() sem params sempre voltava
// só a primeira página. Como não há teto real pro número de incorporadoras,
// percorre todas as páginas em vez de só aumentar um limit fixo.
const toRelativeUrl = (url: string | null): string | null => {
  if (!url) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    return `${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};

export const incorporadoraService = {
  async getAll(): Promise<Incorporadora[]> {
    let url: string | null = `${BASE_URL}?limit=100&offset=0`;
    const resultados: Incorporadora[] = [];
    const visitadas = new Set<string>();

    while (url) {
      if (visitadas.has(url)) break; // protege contra "next" repetido
      visitadas.add(url);

      const response = await api.get<PaginatedResponse<Incorporadora>>(url);
      resultados.push(...response.data.results);
      url = toRelativeUrl(response.data.next);
    }

    return resultados;
  },

  async listarParaSelecao(): Promise<Incorporadora[]> {
    return this.getAll();
  },

  async getById(id: number): Promise<Incorporadora> {
    const response = await api.get<Incorporadora>(`${BASE_URL}${id}/`);
    return response.data;
  },

  async create(data: IncorporadoraCreate): Promise<Incorporadora> {
    const response = await api.post<Incorporadora>(BASE_URL, data);
    return response.data;
  },

  async update(id: number, data: IncorporadoraUpdate): Promise<Incorporadora> {
    const response = await api.put<Incorporadora>(`${BASE_URL}${id}/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`${BASE_URL}${id}/`);
  },
};
